import "./css/SigningFlow.css";
import { useState } from "react";

export default function EligibilityWarningScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {
    const warningConsentMessage =
        flowData?.warningConsentMessage || "";

    const [warningAccepted, setWarningAccepted] = useState(false);

    // Validate the backend-provided consent message
    if (warningConsentMessage.trim().length < 10) {
        return (
            <div className="page">
                <div className="page-content">
                    <div className="text-red-600 mt-2">
                        Eligibility warning consent message is unavailable
                        or invalid. Please contact support.
                    </div>
                </div>
            </div>
        );
    }

    const reviewAnswers = () => {
        if (loading) return;

        setError("");

        next({
            action: "review_answers"
        });
    };

    const continueToNext = () => {
        if (loading) return;

        setError("");

        // Checkbox is mandatory
        if (!warningAccepted) {
            setError("Please confirm that you understand and accept the risks before continuing.");
            return;
        }

        next({
            action: "accept_warning",
            warningAccepted: true
        });
    };

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-content warning-page">

                <div className="warning-icon"></div>

                <h2 className="warning-title">
                    Before you continue
                </h2>

                <p className="warning-text">
                    {flowData?.eligibility?.serviceWarnMessage || ""}
                </p>

                {/* <p className="warning-text">
                    The selected medications, conditions, or recent
                    treatments may increase the risk of adverse or
                    unexpected reactions during or after this service.
                    If you are unsure about your eligibility, consult
                    a qualified healthcare provider before proceeding.
                </p>

                <hr className="warning-divider" />

                <p className="warning-text">
                    By continuing, I accept full responsibility for
                    any adverse effects and release
                    {" "}
                    {flowContext.business?.businessName || "[BUSINESS_NAME]"}
                    {" "}
                    and its staff from liability, except in cases of
                    gross negligence or willful misconduct.
                </p> */}

                <div className="warning-checkbox">

                    <input
                        type="checkbox"
                        id="warningAccept"
                        checked={warningAccepted}
                        onChange={(e) => {
                            setWarningAccepted(e.target.checked);
                            setError("");
                        }}
                        disabled={loading}
                    />

                    <label htmlFor="warningAccept">
                        {warningConsentMessage}
                    </label>

                </div>

            </div>

            <div className="page-footer">

                <button
                    className="primary-button"
                    onClick={continueToNext}
                    disabled={loading || !warningAccepted}
                >
                    Accept & Continue
                    <span className="button-arrow">›</span>
                </button>

                <button
                    className="secondary-button"
                    onClick={reviewAnswers}
                    disabled={loading}
                >
                   Review Answers
                </button>

            </div>

        </div>
    );
}